import React from "react";
import { Box, Typography } from "@mui/material";
import SEO from "../images/why-choose-censoft-2.jpg";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";

const steps = [
  {
    title: "Early Access to Cutting-Edge Technologies",
    desc: "Clients gain seamless access to the latest technologies, staying ahead in a rapidly evolving market. ",
    icon: "🔍",
  },
  {
    title: "Industry-Aligned Expertise",
    desc: "Through close collaboration with top product leaders, we ensure complete alignment with key client success factors.",
    icon: "👥",
  },
  {
    title: "Specialized Talent Pool",
    desc: "Our highly skilled professionals enable faster deployment and shorter turnaround times.",
    icon: "📝",
  },
  {
    title: "Cost-Effective Offshore Solutions",
    desc: "Our offshore center supports scalable growth at reduced costs, minimizing onsite expenses for clients.",
    icon: "🏅",
  },
];

const StepCard = ({ step, index }) => (
  <Box
    sx={{
      p: { xs: 2, sm: 3, md: 4 },
      backgroundColor: "white",
      borderRadius: 6,
      boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.08)",
      width: "100%",
      maxWidth:400,
      minHeight: { xs: 130, sm: 140, md: 200 },
      position: "relative",
      justifyContent: "center",
      border : "1px solid #1b2a32"
    }}
  >
    {/* Header: Icon + Title + Step Number */}
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      {/* Icon and Title */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            backgroundColor: "#f0f4ff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 18,
            color: "#3A00FF",
            border: "2px solid rgb(255, 0, 0)",
          }}
        >
          {step.icon}
        </Box>
      </Box>

      {/* Step Number */}
      <Box
        sx={{
          backgroundColor: "#f1f0ff",
          color: "#333",
          borderRadius: "50%",
          width: 50,
          height: 50,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 20,
          fontWeight: 600,
        }}
      >
        {`0${index + 1}`}
      </Box>
    </Box>

    {/* Title and Description */}
    <Box sx={{ mt: 1 }}>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 900, fontSize: { xs: 17, sm: 25 },fontFamily: "Aeonik",mb : 1 }} 
      >
        {step.title}
      </Typography>
      {step.desc && (
        <Typography
          variant="body2"
          sx={{ fontSize: { xs: 12, sm: 14 }, color: "text.secondary" }}
        >
          {step.desc}
        </Typography>
      )}
    </Box>
  </Box>
);

const SEOWorkflow = () => {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        px: 2,
        background: "#090d16", //#060b11,1b2a32,090d16
        minHeight: "100vh",
      }}
    >
      <Box textAlign="center" mb={4}>
        <Typography
          variant="caption"
          sx={{
            display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#fff",
      px: 2,
      py: 0.5,
      borderRadius: 10,
      border: "0.5px solid gray",
      fontWeight: 600,
      gap: 0.5,
      justifyContent: "center",
          }}
        >
          <SettingsSuggestIcon sx={{ fontSize: 16, color: "blue" }} />
          Our working process
        </Typography>

        <br />
        <br />

        <Typography
          variant="h3"
          color="white"
          fontWeight="bold"
          gutterBottom
          textTransform="uppercase"
          sx={{ textAlign: "center" }}
        >
          Why choose CenSoft
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "center",
          alignItems: { xs: "flex-start", md: "flex-start" },
          mt: 8,
          gap: { xs: 4, md: 12 },
          px: { xs: 2, md: 0 },
          mr: { xs: 2.5, md: 0 },
        }}
      >
        {/* Left Column - Step Cards */}
        <Box
          sx={{
            position: "relative",
            width: { xs: "100%", md: "100%" },
            maxWidth: 500,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center", // center on mobile
            mx: "auto",
          }}
        >
          {steps.map((step, index) => (
            
            <Box
              key={index}
              sx={{
                position: { xs: "relative", md: "sticky" },
                top: { xs: "auto", md: `${20 + (index * 9)}%` },
                mb: { xs: 4, md: 10 },
                zIndex: steps.length + index,
                width: "90%",
              }}
            >
              <StepCard step={step} index={index} />
            </Box>
          ))}
        </Box>

        {/* Right Column - Floating Image (Only Desktop) */}
        <Box
          component="img"
          src={SEO}
          alt="SEO Workflow"
          sx={{
            display: { xs: "wrap", md: "block" },
            maxWidth: 800,
            width: "100%",
            objectFit: "contain",
            animation: "float 4s ease-in-out infinite",
            position: "sticky",
            top: "30%",
            height:{xs:250,sm:350,md:500,lg : 600},
            "@keyframes float": {
              "0%": { transform: "translateY(0)" },
              "50%": { transform: "translateY(-15px)" },
              "100%": { transform: "translateY(30)" },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default SEOWorkflow;
